import React from 'react';
import ReactDOM from 'react-dom/client';
import CustomerForm from './Components/Customerform';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAxXmHudEa8eVbrRhWHh5XWsoqLNtW0A80",
  authDomain: "asbt-65120.firebaseapp.com",
  projectId: "asbt-65120",
  storageBucket: "asbt-65120.firebasestorage.app",
  messagingSenderId: "377405503369",
  appId: "1:377405503369:web:e36eac2c98a70fdf9dd358",
  measurementId: "G-T7367L3MHG"
};

// Initialize Firebase
initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CustomerForm />
  </React.StrictMode>
);